// extracted by mini-css-extract-plugin
export default {"inputContainer":"iYN0eL65HlA2kU6QYv6W","input":"jC7felrEqMm4Q9ZcvyOr","labelContainer":"SNvTikdqEUuOS9z5ZYvj","label":"w0vN7J4YAUDOiiQ_vhU0"};